var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-table",
    {
      staticClass: "table",
      attrs: {
        multiple: _vm.multiple,
        "no-data-text": "No tienes pasajeros",
        data: _vm.passengers
      },
      scopedSlots: _vm._u([
        {
          key: "default",
          fn: function(ref) {
            var data = ref.data
            return _vm._l(data, function(tr, indextr) {
              return _c(
                "vs-tr",
                { key: indextr, attrs: { data: tr } },
                [
                  _c("vs-td", { attrs: { data: data[indextr].label } }, [
                    _vm._v(" " + _vm._s(tr.label) + " ")
                  ]),
                  _c("vs-td", { attrs: { data: data[indextr].iut } }, [
                    _vm._v(" " + _vm._s(tr.iut) + " ")
                  ])
                ],
                1
              )
            })
          }
        }
      ]),
      model: {
        value: _vm.passengersSelected,
        callback: function($$v) {
          _vm.passengersSelected = $$v
        },
        expression: "passengersSelected"
      }
    },
    [
      _c(
        "template",
        { slot: "thead" },
        [_c("vs-th", [_vm._v("Nombre")]), _c("vs-th", [_vm._v("Rut")])],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }